import styled from "styled-components";
import BaseButton from "./BaseButton";
import { darken } from "@material-ui/core/styles/colorManipulator";

export default styled(BaseButton)`
    background: ${(props) => props.theme.palette.cta.background};
    color: ${(props) => props.theme.palette.cta.text};

    :hover {
        background: ${(props) => darken(props.theme.palette.cta.background, 0.08)};
        transition: all 0.3s ease;
    }

    :active {
        background: ${(props) => darken(props.theme.palette.cta.background, 0.25)};
    }
`;
